import { MultiSelectFilter } from '../MultiSelectFilter';
import { useStyles } from './styles/SystemFilters.styles';
import { SystemModelMap, SystemStatus, SystemFilterOption } from '@consts/systems';
import { SearchBar } from '@components/SearchBar';
import { useMemo, type Dispatch, type SetStateAction } from 'react';

import type { SystemFilter } from '@/types/systems';
import { OrgFilters } from '@components/OrgFilters';

const statusOptions = Object.keys(SystemStatus);

interface SystemTableFiltersProps {
    filters: SystemFilter;
    setFilter: (key: string, value: string, selectOne?: boolean) => void;
    setSearchTerm?: Dispatch<SetStateAction<string>>;
    searchTerm?: string;
    showLocations?: boolean;
}

export const SystemTableFilters = ({
    filters,
    setFilter,
    searchTerm,
    setSearchTerm,
    showLocations,
}: SystemTableFiltersProps) => {
    const classes = useStyles();

    const models = useMemo(
        () => Object.entries(SystemModelMap).map(([modelNumber, modelName]) => ({ modelNumber, modelName })),
        []
    );

    return (
        <div className={classes.filterContainer}>
            {searchTerm !== undefined && setSearchTerm && <SearchBar value={searchTerm} onSearch={setSearchTerm} />}

            <MultiSelectFilter
                label={'Model'}
                options={models}
                idKey={'modelNumber'}
                value={filters.model}
                onChange={(value) => setFilter(SystemFilterOption.Model, value, true)}
                getLabelValue={(option) => option.modelName}
                disabled={Boolean(searchTerm)}
            />

            <MultiSelectFilter
                search
                label={'Status'}
                options={statusOptions}
                value={filters.status}
                onChange={(value) => setFilter(SystemFilterOption.Status, value)}
                getLabelValue={(option) => option}
                disabled={Boolean(searchTerm)}
            />

            <OrgFilters
                orgFilters={filters}
                setOrgFilters={setFilter}
                showLocations={showLocations}
                disabled={Boolean(searchTerm)}
            />
        </div>
    );
};
